module.exports = __webpack_public_path__ + "img/lemon-left-4.91d887e8.png";